import React from 'react';
import { Box } from '@heycater/design-system';
import Image from 'next/image';
import styled from 'styled-components';

const PARTNERS = {
  logos: [
    {
      src: '/artifacts/images/marketing_pages/barmer.webp',
      height: 16,
      alt: 'Barmer',
    },
    {
      src: '/artifacts/images/marketing_pages/hellofresh.webp',
      height: 48,
      alt: 'HelloFresh',
    },
    {
      src: '/artifacts/images/marketing_pages/audi.webp',
      height: 36,
      alt: 'Audi',
    },
    {
      src: '/artifacts/images/marketing_pages/infarm.webp',
      height: 24,
      alt: 'Infarm',
    },
    {
      src: '/artifacts/images/marketing_pages/ebay.webp',
      height: 40,
      alt: 'Ebay',
    },

    {
      src: '/artifacts/images/marketing_pages/dell.webp',
      height: 100,
      alt: 'Dell',
    },
  ],
};

function PartnerLogoBubbles() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      py={4}
      flexWrap="wrap"
      sm={{ flexWrap: 'no-wrap', py: 4 }}
    >
      {PARTNERS.logos.map((partner) => (
        <PartnerBubble key={partner.alt}>
          <div className="img-wrapper">
            <Image alt="" {...partner} width={100} />
          </div>
        </PartnerBubble>
      ))}
    </Box>
  );
}

const PartnerBubble = styled.div`
  height: 140px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  width: 120px;

  ${(props) => props.theme.breakpoints.up('md')} {
    margin-left: -${(props) => props.theme.spacing(1)}px;
    margin-right: -${(props) => props.theme.spacing(1)}px;
    box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);
    border-radius: 50%;
    width: 140px;
  }

  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-left: ${(props) => props.theme.spacing(1)}px;
    margin-right: ${(props) => props.theme.spacing(1)}px;
    margin-bottom: ${(props) => props.theme.spacing(1)}px;
    box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);
    border-radius: 500px;
    width: 140px;
  }
`;

export default PartnerLogoBubbles;
